<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            選択されたノードを削除しますがよろしいでしょうか？
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              削除されたノードは復元することはできません。
              削除したい箇所かどうか確認の上削除をお願いします。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive=false">いいえ</a>
          <a class="card-footer-item" @click="clickDeleteNode()">はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import makeUpdateTemplateData from '@/functions/makeUpdateTemplateData'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'ModalDeleteScnario',
  data () {
    return {
      isCardModalActive: false,
      scenarioDelete: null
    }
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['selectChatbot', 'scenarioTable', 'modalScenario', 'isModalDeleteNode', 'isRoboPartsSetView', 'modalScenarioIndex', 'selectTemplateId']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalDeleteNode () {
      this.isCardModalActive = this.isModalDeleteNode
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickDeleteNode () {
      this.sendControlLogRelatedChatBot('ノード削除', 'シナリオ編集画面にてノードの接続を削除した。', this.selectChatbot)
      this.scenarioDelete = this.modalScenario
      this.scenarioDelete.select[this.modalScenarioIndex].next_node = ''
      this.$store.dispatch('chatbot/setScenario', { companyid: this.user.companyID, scenarioName: this.scenarioDelete.name, scenario: this.scenarioDelete })
        .then(() => {
          this.setEditStatus(this.selectChatbot.bot_id, this.user.userHash, this.scenarioDelete.pk)
          // this.$store.dispatch('chatbot/storySet')
        })
      if (this.isRoboPartsSetView) {
        this.$store.dispatch('chatbot/closeModalScenario')
      }
      this.isCardModalActive = false
    },
    setEditStatus (botID, userHash, scenarioID) {
      // ロボの編集情報を送信
      let editData = {
        'uuid'       : userHash,
        'bot_id'     : botID,
        'scenario_id': scenarioID,
      }
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
        '[SETSCENARIO]' + JSON.stringify(editData)
      )
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalDeleteNode.vue